// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"cc3be0e6","container":"f6280111","dayOfMonth":"cdb3875a","dim":"fce2f605","isToday":"b1842975","answers":"c6820347"};